require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shanti-ekambaram.json") })
        }
      }, "path---shanti-ekambaram");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shanti-ekambaram!./.cache/json/shanti-ekambaram.json
// module id = 653
// module chunks = 231608221292675